/**
 * Some uploads arrive with a URL-encoded file name ("Final%20Return.pdf").
 */
export function displayTitle(title: string) {
  try {
    return decodeURIComponent(title)
  } catch {
    return title
  }
}
